module.exports = __webpack_public_path__ + "media/scholarship_winners/david-sw-21737ce2.png";